import { React } from "react";
import "./Homescreen.scss";

import Logo from "../Images/icon-Container.png";

import VenueNow from "../Images/logo-rectangle-venuenow.png";

function Homescreen({ homeScreenClicked }) {
  return (
    <div className="home__base" onClick={homeScreenClicked}>
      <div className="home__title">
        <h1 className="home__title__text">Welcome, tap anywhere to begin.</h1>
      </div>
      <div className="home__image">
        <img className="home__image__logo" src={Logo} alt="Welcome" />
      </div>
      <div className="home__footer">
        <img className="home__footer__logo" src={VenueNow} alt="Welcome" />
      </div>
    </div>
  );
}

export default Homescreen;
